// Signup
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';

export const SIGNUP_NOT_CONFIRM_EMAIL = 'SIGNUP_NOT_CONFIRM_EMAIL';

export const START_WITHOUT_TOKEN = 'START_WITHOUT_TOKEN';

export const START_WITH_TOKEN_REQUEST = 'START_WITH_TOKEN_REQUEST';
export const START_WITH_TOKEN_SUCCESS = 'START_WITH_TOKEN_SUCCESS';
export const START_WITH_TOKEN_FAIL = 'START_WITH_TOKEN_FAIL';

export const USER_SIGNUP = 'USER_SIGNUP';
export const INVITE_SIGNUP = 'INVITE_SIGNUP';

export const RESEND_VERIFICATION_EMAIL_REQUEST =
  'RESEND_VERIFICATION_EMAIL_REQUEST';
export const RESEND_VERIFICATION_EMAIL_SUCCESS =
  'RESEND_VERIFICATION_EMAIL_SUCCESS';
export const RESEND_VERIFICATION_EMAIL_ERROR =
  'RESEND_VERIFICATION_EMAIL_ERROR';

// Register company
export const REGISTER_COMPANY_REQUEST = 'REGISTER_COMPANY_REQUEST';
export const REGISTER_COMPANY_SUCCESS = 'REGISTER_COMPANY_SUCCESS';
export const REGISTER_COMPANY_ERROR = 'REGISTER_COMPANY_ERROR';

// Fetch company detail
export const FETCH_COMPANY_DETAIL_BY_EMAIL_REQUEST =
  'FETCH_COMPANY_DETAIL_BY_EMAIL_REQUEST';
export const FETCH_COMPANY_DETAIL_BY_EMAIL_SUCCESS =
  'FETCH_COMPANY_DETAIL_BY_EMAIL_SUCCESS';
export const FETCH_COMPANY_DETAIL_BY_EMAIL_ERROR =
  'FETCH_COMPANY_DETAIL_BY_EMAIL_ERROR';

// Signin
export const SIGNIN_REQUEST = 'SIGNIN_REQUEST';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_ERROR = 'SIGNIN_ERROR';

export const GOOGLE_SIGNIN_REQUEST = 'GOOGLE_SIGNIN_REQUEST';
export const GOOGLE_SIGNIN_SUCCESS = 'GOOGLE_SIGNIN_SUCCESS';
export const GOOGLE_SIGNIN_ERROR = 'GOOGLE_SIGNIN_ERROR';

export const CHECK_AUTHORIZATION = 'CHECK_AUTHORIZATION';

export const SIGNOUT = 'SIGNOUT';

// Invitation
export const INVITATION_ACCEPT_REQUEST = 'INVITATION_ACCEPT_REQUEST';
export const INVITATION_ACCEPT_SUCCESS = 'INVITATION_ACCEPT_SUCCESS';
export const INVITATION_ACCEPT_ERROR = 'INVITATION_ACCEPT_ERROR';

export const ACCEPT_COMPANY_OWNER_INVITATION_REQUEST =
  'ACCEPT_COMPANY_OWNER_INVITATION_REQUEST';
export const ACCEPT_COMPANY_OWNER_INVITATION_SUCCESS =
  'ACCEPT_COMPANY_OWNER_INVITATION_SUCCESS';
export const ACCEPT_COMPANY_OWNER_INVITATION_ERROR =
  'ACCEPT_COMPANY_OWNER_INVITATION_ERROR';

// Forgot password
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';

// Reset password
export const VERIFY_RESET_PASSWORD_TOKEN_REQUEST =
  'VERIFY_RESET_PASSWORD_TOKEN_REQUEST';
export const VERIFY_RESET_PASSWORD_TOKEN_SUCCESS =
  'VERIFY_RESET_PASSWORD_TOKEN_SUCCESS';
export const VERIFY_RESET_PASSWORD_TOKEN_ERROR =
  'VERIFY_RESET_PASSWORD_TOKEN_ERROR';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_ERROR = 'VERIFY_EMAIL_ERROR';

export const SET_AUTH_USER = 'SET_AUTH_USER';

export const SYNC_AUTH_USER_REQUEST = 'SYNC_AUTH_USER_REQUEST';
export const SYNC_AUTH_USER_SUCCESS = 'SYNC_AUTH_USER_SUCCESS';
export const SYNC_AUTH_USER_FAIL = 'SYNC_AUTH_USER_FAIL';

export const VERIFY_MEMO_REQUEST = 'VERIFY_MEMO_REQUEST';
export const VERIFY_MEMO_SUCCESS = 'VERIFY_MEMO_SUCCESS';
export const VERIFY_MEMO_FAIL = 'VERIFY_MEMO_FAIL';
export const COMPANY_SIGN_OUT_REQUEST = 'COMPANY_SIGN_OUT_REQUEST';
export const COMPANY_SIGN_OUT_SUCCESS = 'COMPANY_SIGN_OUT_SUCCESS';
export const COMPANY_SIGN_OUT_FAIL = 'COMPANY_SIGN_OUT_FAIL';

// refresh

export const REFRESH_REQUEST = 'REFRESH_REQUEST';
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS';
export const REFRESH_ERROR = 'REFRESH_ERROR';

export const DECLINE_BUSINESS_MEMBERS_REQUEST = 'DECLINE_BUSINESS_MEMBERS_REQUEST';
export const DECLINE_BUSINESS_MEMBERS_SUCCESS = 'DECLINE_BUSINESS_MEMBERS_SUCCESS';
export const DECLINE_BUSINESS_MEMBERS_FAIL = 'DECLINE_BUSINESS_MEMBERS_FAIL';
export const REGISTER_BUDDI_WALLET_MODAL = 'REGISTER_BUDDI_WALLET_MODAL';
export const BUDDI_WALLET_REGISTERED_FLAG = 'BUDDI_WALLET_REGISTERED_FLAG';
export const TRIGGER_BUDDI_WALLET_MODAL = 'TRIGGER_BUDDI_WALLET_MODAL';

// used when don't want to display register buddi wallet on small window open for import contacts
export const CAN_REGISTER_BUDDI_WALLET_MODAL = 'CAN_REGISTER_BUDDI_WALLET_MODAL';


export const SET_CHAT_ID = 'SET_CHAT_ID';
export const SET_USER_PAYMENT_PLAN_REQUEST = 'SET_USER_PAYMENT_PLAN_REQUEST';
export const SET_USER_PAYMENT_PLAN_SUCCESS = 'SET_USER_PAYMENT_PLAN_SUCCESS';
export const SET_USER_PAYMENT_PLAN_FAIL = 'SET_USER_PAYMENT_PLAN_FAIL';
